import PromocodesListItem from '~/view/screens/MarketingScreen/screens/PromocodesScreen/components/PromocodesListItem/PromocodesListItem';
import { observer } from 'mobx-react';
import { PROMOCODE_SORT_COLUMN } from '~/view/screens/MarketingScreen/screens/PromocodesScreen/types/promocodes';
import { SORTING_DIRECTION } from '~/constants/main';
import { promocodeStore } from '~/view/screens/MarketingScreen/screens/PromocodesScreen/store/promocodeStore';
import { localeStore } from '~/mobx/localesStore';
import { emptyArray } from '~/utils/helpers';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import LogLink from '~/view/components/LogLink';
import { SCREENS } from '~/constants/screens';
import React from 'react';
import Pagination from '~/view/components/Controls/PaginationOld/PaginationOld';

@observer
export default class PromocodesList extends React.Component<{}, {}> {
  changeSorting = (sortField: PROMOCODE_SORT_COLUMN | undefined, sortDir: SORTING_DIRECTION | undefined) => {
    promocodeStore.setFilters({ sort_field: sortField, sort_dir: sortDir }, false);
  };

  renderContent = () => {
    if (!promocodeStore.pagination.total && !promocodeStore.pagination.loading) {
      return <p className="text-size-32 my-auto mx-auto">{localeStore.t('promocodes_not_found')}</p>;
    } else
      return !promocodeStore.pagination.total && promocodeStore.pagination.loading
        ? emptyArray().map((_, index) => <PromocodesListItem key={'key-' + String(index)} />)
        : promocodeStore.pagination.data.map((promocode) => <PromocodesListItem key={promocode.id} promocode={promocode} />);
  };

  public render() {
    return (
      <div className="d-flex flex-column flex-grow-1 pt-4">
        <div className="d-flex flex-row mb-4 pr-5">
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="hint_name"
            columnName={PROMOCODE_SORT_COLUMN.NAME}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="w-19"
          />
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="discount_type"
            columnName={PROMOCODE_SORT_COLUMN.DISCOUNT_TYPE}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="w-20"
          />
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="amount"
            columnName={PROMOCODE_SORT_COLUMN.AMOUNT}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="w-15"
          />
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="start_date"
            columnName={PROMOCODE_SORT_COLUMN.START_DATE}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="w-17"
          />
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="expiry_date"
            columnName={PROMOCODE_SORT_COLUMN.EXPIRY_DATE}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="w-17"
          />
          <ColumnTitle<PROMOCODE_SORT_COLUMN>
            title="minimum_order"
            columnName={PROMOCODE_SORT_COLUMN.MIN_ORDER}
            currentField={promocodeStore.filters.sort_field}
            currentDir={promocodeStore.filters.sort_dir}
            setFilters={this.changeSorting}
            className="promocodes-list__column-min-order w-12"
          />
        </div>
        <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height pr-4" className="mb-3">
          {this.renderContent()}
        </ScrollableBlock>
        <Pagination pagination={promocodeStore.pagination} onChange={promocodeStore.fetchPromocodes} overlayClassName="overlay_white" />
        {promocodeStore.pagination.total ? <LogLink link={SCREENS.PROMOCODE_LOG()} /> : null}
      </div>
    );
  }
}
